// extracted by mini-css-extract-plugin
module.exports = {"section":"RelevantConcepts_section__Uv50d","sectionTitle":"RelevantConcepts_sectionTitle__g4T3J","sectionContent":"RelevantConcepts_sectionContent__mWZ4i"};